export default {
  header: 'Information für Platz-Nr. "{place}"',
  placeStatus: 'Platz Status',
  reserved: 'Reserviert',
  holdingTime: 'Restverweilzeit [min]',
  loadStatus: 'Chargen Status',
  cellLoadNo: 'Abl. Charge-Nr.',
  targetStartTime: 'Sollstartzeit',
  bookedOnPlace: 'Gebucht auf Platz',
  plcLoadNo: 'SPS Charge-Nr.',
  box: 'Box',
  prio: 'Priorität',
  comment: 'Kommentar',
  noActiveProcessFlow: 'Kein aktiver Prozessablauf',
  noParts: 'Keine Teile',
  processFlow: 'Prozessablauf',
  content: 'Inhalt',
  confirmStartProcessFlowNow: 'Sind Sie sicher, dass Sie den Prozessablauf jetzt starten möchten?',
  name: 'Name',
  description: 'Beschreibung',
  booked: 'Gebucht',
  modification: 'Änderung',
  unloaded: 'Entladen',
  started: 'Gestartet',
  finished: 'Beendet',
  loadFinalTest: 'Endtest laden',
  status: 'Status',
  parts: 'Teile',
  loadingPlace: 'Ladeplatz',
};
